import { getTimeRange } from '../../../../../../constants/helpers/dates';

import { CustomerEnrollmentReportCreateForm } from './interfaces';

export const mapTableDataIntoApiFormat = (report: CustomerEnrollmentReportCreateForm) => ({
  name: report.name,
  metadata: {
    timeRange: getTimeRange({ from: report.from, to: report.to }),
    statuses: report.statuses,
    operationIds: report.operationIds,
    customerMsisdns: report.customerMsisdns,
    providerNames: report.providerNames
  }
});
